// Static copy for HomeBookingWidget — extracted verbatim so the widget
// file focuses on state + rendering. Every key is used by the widget or
// by its extracted step components. Do not delete keys without a grep
// across `src/components/**` first.

export const COPY = {
  overline:     { en: "Plan your stay", fr: "Planifier votre séjour", es: "Planifica tu estancia" },
  title:        { en: "Begin a southern Morocco journey", fr: "Commencer un voyage dans le sud du Maroc", es: "Comenzar un viaje por el sur de Marruecos" },
  hotels_label: { en: "Hotels & Camps",    fr: "Hôtels & Camps",       es: "Hoteles y Campamentos" },
  hotels_p:     { en: "Select one or more", fr: "Sélectionner un ou plusieurs", es: "Seleccionar uno o varios" },
  empty:        { en: "Pick one or more properties to start building your inquiry. Each becomes its own editable block below.", fr: "Choisissez une ou plusieurs adresses pour commencer votre demande. Chaque adresse devient un bloc éditable indépendant.", es: "Elige una o varias propiedades para empezar tu solicitud. Cada una se convierte en un bloque editable independiente." },
  selected:     { en: "selected",   fr: "sélectionné(s)",  es: "seleccionado(s)" },
  cta:          { en: "Check Inquiry",     fr: "Vérifier la demande", es: "Comprobar la solicitud" },
  cta_more:     { en: "Add another property", fr: "Ajouter une autre adresse", es: "Añadir otra propiedad" },
  any_prop:     { en: "Choose a property",   fr: "Choisir une adresse",    es: "Elegir una propiedad" },
  done:         { en: "Done", fr: "Terminer", es: "Hecho" },
  clear_all:    { en: "Clear all", fr: "Tout effacer", es: "Borrar todo" },

  // ── Clear-All confirmation dialog ───────────────────────────────
  // Triggered before performing a full reset of the entire booking
  // enquiry (hotels, services, contact form, validation, widget step,
  // mobile-wizard step, and localStorage). The dialog deliberately
  // uses the editorial palette rather than the generic shadcn
  // <AlertDialog>, which clashes with the rest of the site.
  clear_confirm_title: {
    en: "Clear your entire booking enquiry?",
    fr: "Effacer toute votre demande de réservation ?",
    es: "¿Borrar toda tu solicitud de reserva?",
  },
  clear_confirm_body: {
    en: "This removes every selected property, room, extra and the contact details you have entered. The floating summary and the Choose Your House grid will also reset. This cannot be undone.",
    fr: "Ceci supprime chaque adresse sélectionnée, chaque chambre, chaque extra ainsi que les coordonnées saisies. Le récapitulatif et la grille « Choisissez votre maison » seront également réinitialisés. Action irréversible.",
    es: "Se eliminarán todas las propiedades, habitaciones y extras seleccionados, así como los datos de contacto introducidos. El resumen flotante y la cuadrícula « Elige tu casa » también se restablecerán. Esta acción no se puede deshacer.",
  },
  clear_confirm_cancel: { en: "Cancel", fr: "Annuler", es: "Cancelar" },
  clear_confirm_yes: { en: "Clear all", fr: "Tout effacer", es: "Borrar todo" },
  clear_done_toast: {
    en: "Your enquiry has been cleared.",
    fr: "Votre demande a été effacée.",
    es: "Su solicitud ha sido borrada.",
  },
  est_label:    { en: "Indicative",        fr: "Estimation",       es: "Estimación" },
  est_total:    { en: "Estimated total",   fr: "Total estimé",     es: "Total estimado" },
  est_final:    {
    en: (cur) => `Final quote from a host within 24 hours · invoices issued in MAD · indicative ${cur}`,
    fr: (cur) => `Devis final d'un hôte sous 24 heures · factures en MAD · indicatif ${cur}`,
    es: (cur) => `Cotización final de un anfitrión en 24 horas · facturas en MAD · indicativo ${cur}`,
  },
  bulk_helper:  { en: "Sets the total — existing edits are kept.", fr: "Définit le total — vos modifications sont conservées.", es: "Define el total — tus cambios se conservan." },

  // ── Progressive multi-step flow copy ─────────────────────────────
  step1_label: { en: "Accommodation", fr: "Hébergement", es: "Alojamiento" },
  step2_label: { en: "Extras", fr: "Extras", es: "Extras" },
  step3_label: { en: "Your details", fr: "Vos coordonnées", es: "Sus datos" },
  step_completed: { en: "Step complete", fr: "Étape terminée", es: "Paso completado" },

  cta_continue_extras: {
    en: "Continue to extras",
    fr: "Continuer vers les extras",
    es: "Continuar a los extras",
  },
  cta_continue_details: {
    en: "Continue to details",
    fr: "Continuer vers les détails",
    es: "Continuar a los detalles",
  },
  cta_skip: { en: "Skip", fr: "Passer", es: "Omitir" },
  cta_back: { en: "Back", fr: "Retour", es: "Atrás" },
  cta_send: { en: "Send inquiry", fr: "Envoyer la demande", es: "Enviar solicitud" },
  cta_sending: { en: "Sending…", fr: "Envoi…", es: "Enviando…" },

  step2_overline: { en: "Step 02 · Extras (optional)", fr: "Étape 02 · Extras (optionnel)", es: "Paso 02 · Extras (opcional)" },
  step2_title: { en: "Add experiences", fr: "Ajouter des expériences", es: "Añadir experiencias" },
  step2_sub: {
    en: "Bundle excursions, spa rituals, transfers or a curated itinerary into the same enquiry. Selecting an extra is optional — feel free to skip if you only want stays.",
    fr: "Regroupez excursions, rituels de spa, transferts ou un itinéraire sur mesure dans la même demande. Étape optionnelle — passez si vous ne souhaitez que des séjours.",
    es: "Agrupe excursiones, rituales de spa, traslados o un itinerario a medida en la misma solicitud. Es opcional — omita si solo desea alojamientos.",
  },

  step3_overline: { en: "Step 03 · Your details", fr: "Étape 03 · Vos coordonnées", es: "Paso 03 · Tus datos" },
  step3_title: { en: "Tell us about the trip", fr: "Parlez-nous du voyage", es: "Háblenos del viaje" },
  step3_sub: {
    en: "The more texture you give us, the more bespoke the proposal that comes back. We answer within 24 hours, in your language.",
    fr: "Plus vous nous donnez de matière, plus la proposition sera sur mesure. Nous répondons sous 24 heures, dans votre langue.",
    es: "Cuanta más textura nos des, más a medida será la propuesta. Respondemos en 24 horas, en tu idioma.",
  },

  no_deposit: {
    en: "No deposit required. We answer within 24 hours, in your language.",
    fr: "Aucun acompte requis. Nous répondons sous 24 heures, dans votre langue.",
    es: "Sin depósito. Respondemos en 24 horas, en tu idioma.",
  },
};
